import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { CompanySettingFeatureComponent } from './company-setting-feature/company-setting-feature.component';
import { CompanySettingPresenterComponent } from './company-setting-presenter/company-setting-presenter.component';
import * as store from './store';

@NgModule({
  declarations: [
    CompanySettingFeatureComponent,
    CompanySettingPresenterComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(store.companySettingsFeatureKey, store.reducer),
    EffectsModule.forFeature([store.CompanySettingEffects])
  ]
})
export class CompanySettingModule { }
